<template>
  <v-footer
    fixed
    padless
    elevation="7"
    class="hidden-md-and-up zindex"
    :class="cardClass"
    color="grey lighten-4"
    v-if="isMobile"
  >
    <v-row>
      <v-col cols="6">
        <v-btn :color="color" @click="back" :loading="loading" outlined>{{ $t(prevBtnText) }}</v-btn></v-col
      >
      <v-col cols="6" align="right">
        <v-btn
          elevation="0"
          v-if="showNext"
          @click="forward"
          :disabled="disabled"
          :loading="loading"
          :color="color"
          :dark="!disabled"
        >
          {{ $t(nextBtnText) }}
        </v-btn>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script lang="ts">
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class BookingNavigation extends Vue {
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: "bookingForm.common.prev" })
  prevBtnText!: string;

  @Prop({ default: "bookingForm.common.next" })
  nextBtnText!: string;

  @Prop({ default: false })
  showNext!: boolean;

  @Prop({ default: "pa-4 mx-auto no-top-round-corners mt-n8" })
  cardClass!: string;

  back() {
    this.$emit("back", true);
  }

  forward() {
    this.$emit("forward", true);
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
</script>
<style scoped>
.no-top-round-corners {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 2px solid #444444;
}
</style>
